import {
  API_MINING_ACTIVATE,
  API_MINING_INFO,
  API_MINING_RELEASE,
  API_MINING_UNLOCK,
} from "config/api.url.constant";
import Api from "services/api";

export const getMiningInfo = async () => {
  return Api.get(API_MINING_INFO);
};

export const unLockMining = async (data: { miningId: string }) => {
  return Api.post(API_MINING_UNLOCK, data);
};

export const releaseMining = async (data: { history: string }) => {
  return Api.post(API_MINING_RELEASE, data);
};

export const activateMining = async (data: { miningId: string }) => {
  return Api.post(API_MINING_ACTIVATE, data);
};
